import * as routerActions from 'connected-react-router'
import { useDispatch } from 'react-redux'

// Actions
import { actions as userSongActions } from 'modules/usersongs/actions'

// Components
import { ContextMenu } from 'kit'

// Hooks
import { useUserSongWithSongs } from 'modules/usersongs/hooks'

// Types
import type { UserSong, Song } from 'types'

import styles from './dropdown.css'

type DropdownProps = {
  userSongId: number
  className?: string
  isUnlicensed: boolean
  userSongState: UserSong['state']
  customButton?: JSX.Element
  licenseOrder?: number
}

export const Dropdown = ({ userSongId, className, isUnlicensed, userSongState, customButton, licenseOrder }: DropdownProps) => {
  const dispatch = useDispatch()
  const userSong = useUserSongWithSongs(userSongId)
  const unpublished = (userSong?.samples[0].song as Song).state !== 2

  const handleDeleteSong = () => {
    if (window.confirm('Are you sure you want to remove the song?')) {
      dispatch(userSongActions.deleteUserSong(userSongId))
    }
  }
  /* TODO(Kitti): Disabled until user song versionong working */
  const items = [
    ...(isUnlicensed && !unpublished
      ? [
          <ContextMenu.Item
            text="License song"
            onClick={() => dispatch(routerActions.push(`/pay/license/${licenseOrder || ''}/`))}
            key="1"
          />,
        ]
      : []),
    ...(isUnlicensed
      ? [
          <ContextMenu.Item
            text="Edit song"
            onClick={() => dispatch(routerActions.push(`?modal=usersong&userSongId=${userSongId}`))}
            key="2"
          />,
        ]
      : []),
    ...(!unpublished
      ? [
          <ContextMenu.Item
            text="Send song"
            onClick={() => dispatch(routerActions.push(`?modal=usersongsend&userSongId=${userSongId}`))}
            key="3"
          />,
        ]
      : []),
    ...(!isUnlicensed && !unpublished && false // eslint-disable-line
      ? [
          <ContextMenu.Item
            text="Create new version"
            onClick={() => dispatch(routerActions.push(`?modal=createversion&userSongId=${userSongId}`))}
            key="4"
          />,
        ]
      : []),
    ...(userSongState === 'UNLICENSED' ? [<ContextMenu.Item text="Delete song" onClick={handleDeleteSong} key="5" />] : []),
  ]

  return (
    <ContextMenu className={className} fitContent customButton={customButton} listClassName={styles.list}>
      {items}
    </ContextMenu>
  )
}

export default Dropdown
